<template>
  <div class="fe-text-body-xs-bold lg:fe-text-body-m-bold">
    {{ title }}
  </div>
</template>

<script>
  export default {
    name: "ReviewTitle",
    props: {
      title: {
        type: String,
        default: "",
      },
    },
  }
</script>
